const Home = {
    headline: 'Hola,',
    myName: 'Mi nombre',
    name: 'Ryan Afrizal',
    githubProfile: 'https://github.com/tisoga',
    desc: "Saya adalah seorang Full Stack Developer, Mobile Developer dan juga Python Programmer yang berasal dari Bandung, Jawa Barat, Indonesia. Terima Kasih Telah Melihat Portfolio Saya. serta silahkan kunjungi Github Profile saya di link dibawah."
}

export default Home